/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';
import { AgGridReact } from 'ag-grid-react';

export const GridContainer = styled.div`
  /* width: 1536px; */
  width: 100%;
  //height: 5000px;
  //height: 1200px;
  //height: 461px;
  /* ${({ height, maxHeight }) => css`
    height: ${height}px;
    max-height: ${maxHeight}px;
  `} */
  margin-bottom: 50px;
`;

export const GridBox = styled.div`
  height: 100%;
  width: 100%;
`;

export const MyGrid = styled(AgGridReact)`
  height: 100%;
  width: 100%;
  text-align: center !important;

  .ag-header,
  .ag-header .ag-header-row:not(.ag-header-row-column-group),
  .ag-header .ag-header-cell:not(.events_header):not(.eventsCohort_header) {
    height: 64px !important;
    min-height: 64px !important;
  }

  // sticky styles start //
  .ag-root-wrapper,
  .ag-root.ag-layout-normal,
  .ag-root.ag-layout-auto-height {
    overflow: unset;
  }

  .ag-body-horizontal-scroll-viewport,
  .ag-horizontal-left-spacer {
    scrollbar-color: #cbd5e1 transparent;
  }

  .ag-body-horizontal-scroll {
    position: sticky;
    bottom: 0;
    left: 0;
  }
  // sticky styles ends //

  .ag-cell-not-inline-editing {
    border: hidden;
  }

  .ag-center-cols-container {
    min-width: 100% !important;
  }

  ${({ classNameFirstEventContent, classNameFirstEventCohortContent }) => {
    if (classNameFirstEventContent) {
      return css`
        .${classNameFirstEventContent} {
          border-left: 1px solid ${Palette.PrimaryGray._200} !important;
        }
        .${classNameFirstEventCohortContent} {
          border-left: 1px solid ${Palette.PrimaryGray._200} !important;
        }
      `;
    }
    return '';
  }}

  .ag-row-hover button {
    visibility: visible;
  }

  .ag-header {
    z-index: 1000;
  }

  .ag-row-pinned {
    height: 100% !important;
  }

  ${({ isShadow }) => {
    if (isShadow) {
      return css`
        /*
        .ag-center-cols-viewport,
        .ag-header-viewport,
        .ag-floating-top-viewport {
          box-shadow: 8px 0px 16px -12px rgba(100, 116, 139, 0.42) inset;
        }
        */
        .ag-pinned-left-header,
        .ag-pinned-left-cols-container,
        .ag-pinned-left-floating-top {
          box-shadow: 2px 0px 10px 2px rgba(100, 116, 139, 0.15);
          z-index: 99;
        }
        /* .ag-floating-top-viewport .ag-row-hover {
          border: 1px solid red !important;
          box-shadow: 8px 0px 16px -12px rgba(100, 116, 139, 0.42) inset !important;
        } */
      `;
    }
  }}
  .ag-header-viewport, .ag-pinned-left-header {
    background-color: ${Palette.PrimaryGray._000};
  }
  .ag-header-group-cell.ag-header-group-cell-with-group {
    border-left: 1px solid ${Palette.PrimaryGray._200};
    padding: 0 4px;
  }

  .ag-pinned-left-cols-container {
    border-right: 1px solid ${Palette.PrimaryGray._200};
    background-color: #fff;
  }
  .ag-center-cols-viewport {
    background-color: #fff;
  }

  .ag-floating-top {
    z-index: 1000;
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px !important;
    background: ${Palette.PrimaryGray._100};
    p {
      height: 48px !important;
      max-height: 48px !important;
      min-height: 48px !important;
      color: ${Palette.PrimaryGray._700};
      font-style: normal;
      font-weight: 500;
    }
  }
`;
